import { DownOutlined } from "@ant-design/icons";
import {
  Alert,
  Button,
  Card,
  Dropdown,
  Form,
  notification,
  Space,
  Table,
} from "antd";
import { useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useLocation, useNavigate } from "react-router-dom";
import {
  getAllExams,
  getDetailsCalendar,
  getDetailsExamenRattrapage,
  getListApprenants,
} from "../../../../api/geoprod";
import { useLoader } from "../../../../context/LoaderContext";
import GlobalContext from "../../../../context/GlobalContext";
import dayjs from "dayjs";
import ModalSaisieNotes from "./SaisieNotes/SaisieNotes";
import ConsulterDetailsCalendrierExamenRattrapage from "../GestionCalendrierExamens/ConsulterDetailsCalendrierExamenRattrapage";
import classes from "../../../Etablissements/Etablissements.module.css";
import { BookOpen } from "lucide-react";
const ListeDesExamensEtRattrapages = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [data, setData] = useState([]);
  const { setIsLoading } = useLoader();
  const {
    dates,
    setDates,
    setModulesExamens,
    setModulesRattrapages,
    setGlobalData,
    setCurrentStep,
  } = useContext(GlobalContext);
  const [openModal, setOpenModal] = useState(false);
   const [openModalSaisieNotes, setOpenModalSaisieNotes] = useState(false);
  const params = useLocation();
  const [listeApprenants, setListeApprenants] = useState([]);
    const [listeModules, setListeModules] = useState([]);
  const id_affaire = params?.state?.id_affaire;
const [idStatut, setIdStatut] = useState(params?.state?.id_status || sessionStorage?.getItem("id_statut_session_formation_homologuee"))
  // const id_status = params?.state?.id_status || sessionStorage?.getItem("id_statut_session_formation_homologuee");
const [periode, setPeriode] = useState("")
const [calendarData, setCalendarData] = useState([])
  const [form] = Form.useForm();
const columns = [
  {
    title: t("Période"),
    dataIndex: "periode",
    key: "periode",
    render: (text, record) => {
      if (record?.isYearRow) {
        return {
          children: (
            <div
              style={{
                fontWeight: "bold",
                fontSize: 16,
                textAlign: "center",
                
              }}
            >
              {record.annee}
            </div>
          ),
          props: {
            colSpan: 7
          },
        };
      }
      return text;
    },
  },
  {
    title: t("Date début examen"),
    dataIndex: "date_debut_periode_examen",
    key: "date_debut_periode_examen",
    render: (text, record) => {
      if (record.isYearRow) {
        return { children: null, props: { colSpan: 0 } };
      }
      return text;
    },
  },
  {
    title: t("Date fin examen"),
    dataIndex: "date_fin_periode_examen",
    key: "date_fin_periode_examen",
    render: (text, record) => {
      if (record.isYearRow) {
        return { children: null, props: { colSpan: 0 } };
      }
      return text;
    },
  },
  {
    title: t("Date début rattrapage"),
    dataIndex: "date_debut_periode_rattrapage",
    key: "date_debut_periode_rattrapage",
    render: (text, record) => {
      if (record.isYearRow) {
        return { children: null, props: { colSpan: 0 } };
      }
      return text || "N'existe pas";
    },
  },
  {
    title: t("Date fin rattrapage"),
    dataIndex: "date_fin_periode_rattrapage",
    key: "date_fin_periode_rattrapage",
    render: (text, record) => {
      if (record.isYearRow) {
        return { children: null, props: { colSpan: 0 } };
      }
      return text || "N'existe pas";
    },
  },

  {
    title: t("Actions"),
    key: "actions",
    render: (_, record) => {
      if (record.isYearRow) {
        return { children: null, props: { colSpan: 0 } };
      }
       const lastIndexWithConsulterNote = [...data]
      .reverse()
      .find((item) => item?.consulter_note)?.periode;

    const isLastConsulterNote =
      record?.consulter_note && record?.periode === lastIndexWithConsulterNote;


      return (
          <Space>
          <Dropdown
            menu={{
              items: [
                {
                  label: (
                    <Button
                      size="small"
                      block
                      disabled={!record?.add_calendrier_exam && !record?.add_calendrier_rattrapage}
                      onClick={() => {
                        sessionStorage.removeItem("currentStep");
                        setCurrentStep(0);
                        setIsLoading(true);
                        getDetailsExamenRattrapage(id_affaire)
                          .then((response) => {
                            setIsLoading(false);
                            const mappedmodules = response?.existe?.examen.map(
                              (exam) => ({
                                id: exam?.id_module,
                                name: exam?.name_module,
                                id_md: exam?.id,
                                seuil:exam?.seuil,
                                unite_seuil:exam?.unite_seuil
                              })
                            );
                            const mappedmodulesRattrapage =
                              response?.existe?.rattrapage.map((exam) => ({
                                id: exam?.id_module,
                                name: exam?.name_module,
                                id_md: exam?.id,
                                seuil:exam?.seuil,
                                unite_seuil:exam?.unite_seuil
                              }));

                            if (
                              mappedmodules.length === 0 &&
                              mappedmodulesRattrapage.length === 0
                            ) {
                              notification.warning({
                                message: t("Vous ne disposez pas"),
                                duration: 0,
                              });
                            } else {
                              let newDates = { ...dates };
                              if (
                                mappedmodulesRattrapage &&
                                response?.existe?.date_debut_rattrapage &&
                                response?.existe?.date_fin_rattrapage
                              ) {
                                newDates.rattrapage = {
                                  startDate: dayjs(
                                    response.existe.date_debut_rattrapage,
                                    "YYYY/MM/DD"
                                  ).format("DD/MM/YYYY"),
                                  endDate: dayjs(
                                    response.existe.date_fin_rattrapage,
                                    "YYYY/MM/DD"
                                  ).format("DD/MM/YYYY"),
                                };
                                setModulesRattrapages(mappedmodulesRattrapage);
                                setDates(newDates);
                              }

                              if (
                                mappedmodules &&
                                response?.existe?.date_debut_examen &&
                                response?.existe?.date_fin_examen
                              ) {
                                newDates.examen = {
                                  startDate: dayjs(
                                    response.existe.date_debut_examen,
                                    "YYYY/MM/DD"
                                  ).format("DD/MM/YYYY"),
                                  endDate: dayjs(
                                    response.existe.date_fin_examen,
                                    "YYYY/MM/DD"
                                  ).format("DD/MM/YYYY"),
                                };
                                setModulesExamens(mappedmodules);
                                setDates(newDates);
                              }

                              const dataToSave = {
                                modulesExamens: mappedmodules,
                                modulesRattrapages: mappedmodulesRattrapage,
                                dates: newDates,
                                periode: response?.existe?.periode,
                                modulesExamensSession: mappedmodules,
                                modulesRattrapagesSession:
                                  mappedmodulesRattrapage,
                                datesSession: dates,
                              };
                              sessionStorage.setItem(
                                "globalData",
                                JSON.stringify(dataToSave)
                              );
                              
                              setGlobalData(dataToSave);
                            
                              navigate(
                                "/sessionFormationHomologuee/calendrierExamensRattrapages",
                                {
                                  state: {
                                    id_calendrier_examen:
                                      record?.id_calendrier_examen ,
                                    id_calendrier_rattrapage:
                                      record?.id_calendrier_rattrapage ,
                                      id_affaire:id_affaire,
                                    id_status:idStatut,
                                   
                                  },
                                }
                              );
                            }
                          })
                          .catch(() => {
                            setIsLoading(false);
                          });
                      }}
                    >
                      {t("Ajouter calendrier")}
                    </Button>
                  ),
                },
                 {
                  label: (
                    <Button
                      size="small"
                      block
                      disabled={!record?.consulter_calendrier_exam}
                      onClick={() => {
                        setIsLoading(true);

                        getDetailsCalendar(
                          id_affaire,
                          record?.periode
                        )
                          .then((response) => {
                          
const result = response?.details?.[record?.periode]
                            const allData = [];

    if (Array.isArray(result.examen)) {
      allData.push(
        ...result.examen.map((item) => ({
          ...item,
          type: "examen",
        }))
      );
    }

    if (Array.isArray(result.rattrapage)) {
      allData.push(
        ...result.rattrapage.map((item) => ({
          ...item,
          type: "rattrapage",
        }))
      );
    }
    setCalendarData(allData);
    console.group("record?.consulter_calendrier_exam",record?.consulter_calendrier_exam)
      setOpenModal(true)
                            setIsLoading(false);
                          })
                          .catch((error) => {
                            setIsLoading(false);
                            notification?.error({
                              message: t("Erreur"),
                              description: t(error?.data?.message),
                              duration: 0,
                            });
                          });
                      }}
                    >
                      {t("Consulter calendrier")}
                    </Button>
                  ),
                },
                   {
                  label: (
                    <Button
                      size="small"
                      block
                      disabled={!(
    record?.add_note_exam_DR ||
    (idStatut === import.meta.env.VITE_APP_ID_STATUS_DECISION_FINALE_REFUS_NOTES_APPRENANT_SESSION_HOMOLOGUEE &&
      isLastConsulterNote)
  )}
                      onClick={() => {
                        setIsLoading(true);
                         const isLastRecord = data[data?.length - 1]?.periode === record?.periode;
                        getListApprenants(id_affaire)
                          .then((response) => {
                            
                         setPeriode(record?.periode)
                            setListeApprenants(response?.message?.Data);

                            if(response?.message?.Data.length > 0)
                            {
                           getDetailsCalendar(
                             id_affaire,
                              record?.periode
                            )
                              .then((responseDetailsCalendar) => {
                                
                             const result = Object.values(responseDetailsCalendar.details)[0];
                           
                             navigate(
                                "/sessionFormation/addNotes",
                                {
                                  state: {
                                    listeApprenants : response?.message?.Data,
                                    periode: record?.periode,
                                    year: record?.annee,
                                    listeModules : result,
                                    id_affaire:id_affaire,
                                    rattrapage : result?.rattrapage?.length > 0  ? true : false,
                                    isLastRecord:isLastRecord, 
                                    id_status :idStatut,
                                    isLastConsulterNote:isLastConsulterNote
                                    // modifiable : (id_status === import.meta.env.VITE_APP_ID_STATUS_DECISION_FINALE_REFUS_NOTES_APPRENANT_SESSION_HOMOLOGUEE && isLastConsulterNote) ? true : false 
                                  },
                                }
                              );
                                setIsLoading(false);

                              })
                              .catch((error) => {
                                setIsLoading(false);
                                notification?.error({
                                  message: t("Erreur"),
                                  description: t(error?.data?.message),
                                  duration: 0,
                                });
                              });
                            }
                       else 
                       {
                          setIsLoading(false);
                  notification.warning({
                            message: t(
                              "Aucun apprenant n'est inscrit à cette session de formation"
                            ),
                            duration: 0,
                          });
                       }
                        
                          })
                          .catch((error) => {
                            setIsLoading(false);
                            notification?.error({
                              message: t("Erreur"),
                              description: t(error?.data?.message),
                              duration: 0,
                            });
                          });
                      }}
                    >
                      {t("Saisie notes")}
                    </Button>
                  ),
                },


                    {
                  label: (
                    <Button
                      size="small"
                      block
                    disabled={!record?.consulter_note}
                      onClick={() => {
                     
                        // setOpenModal(true)
                  navigate(
                              "/apprenants/notes",
                              {
                                state: {
                                  periode:record?.periode,
                                  id_affaire:id_affaire
                                 
                                },
                              }
                            );
                      }}
                    >
                      {t("Consulter notes")}
                    </Button>
                  ),
                },
              ],
            }}
            trigger={["click"]}
          >
            <span style={{ cursor: "pointer" }}>
              <Space>
                {t("Liste")}
                <DownOutlined />
              </Space>
            </span>
          </Dropdown>
        </Space>
      );
    },
  },
];

  useEffect(() => {
    setIsLoading(true)
getAllExams(id_affaire).then((response) => {
  
    const modules = response.modules || {};
    const formattedData = [];

    Object.entries(modules).forEach(([annee, semestres]) => {
      formattedData.push({
        key: `year-${annee}`,
        annee,
        isYearRow: true,
      });

      Object.entries(semestres).forEach(([periode, item]) => {
        formattedData.push({
          key: `${annee}-${periode}`,
          annee,
          periode,
          date_debut_periode_examen: item.date_debut_periode_examen
            ? dayjs(item.date_debut_periode_examen, "YYYY/MM/DD").format("DD/MM/YYYY")
            : "N'existe pas",
          date_fin_periode_examen: item.date_fin_periode_examen
            ? dayjs(item.date_fin_periode_examen, "YYYY/MM/DD").format("DD/MM/YYYY")
            : "N'existe pas",
          date_debut_periode_rattrapage: item.date_debut_periode_rattrapage
            ? dayjs(item.date_debut_periode_rattrapage, "YYYY/MM/DD").format("DD/MM/YYYY")
            : "",
          date_fin_periode_rattrapage: item.date_fin_periode_rattrapage
            ? dayjs(item.date_fin_periode_rattrapage, "YYYY/MM/DD").format("DD/MM/YYYY")
            : "",
          id_calendrier_examen: item?.id_calendrier_examen,
          id_calendrier_rattrapage: item?.id_calendrier_rattrapage,
          add_calendrier_exam: item?.add_calendrier_exam,
          add_calendrier_rattrapage: item?.add_calendrier_rattrapage,
          add_note_exam_DR: item?.add_note_exam_DR,
          add_note_rattrapage_DR: item?.add_note_rattrapage_DR,
          consulter_calendrier_exam: item?.consulter_calendrier_exam,
          consulter_note: item?.consulter_note,
          statut: item?.statut || "",
        });
      });
    });


    setData(formattedData);
    setIsLoading(false)
    setIdStatut(response?.statut)
  })
      .catch((error) => {
        setIsLoading(false)
       notification.error({
          message: t("Erreur"),
          description: t(error?.data?.message),
        duration: 0,
      });
      });
  }, []);

  return (
    <div>
      
      <Alert
        type="info"
        style={{ marginBlock: "20px" }}
        message="Configuration"
        description={`Liste des examens et des rattrapages`}
        showIcon
      />
         <Space className={classes.rowButtonCreate}>
        <Button
          className={classes.buttonCreate}
          onClick={ () => {
        navigate("/session/formations");
          }}
        >
          <BookOpen strokeWidth={1.25} />
          {t("Liste des sessions de formation")}
        </Button>{" "}
      </Space>
      <Card title="Liste des examens et des rattrapages" bordered={false}>
        <Table
          locale={{ emptyText: t("Aucune donnée") }}
                  rowClassName={(record) =>
          [true].includes(record.isYearRow) ? "row-total-colored" : ""
        }
          columns={columns}
          dataSource={data}
          className="ant-border-space"
          style={{ overflowX: "auto" }}
          pagination={true}
        />
      </Card>
      {listeApprenants?.length > 0 && listeModules?.examen?.length > 0  && (
        <ModalSaisieNotes
          openModal={openModalSaisieNotes}
          id_affaire={id_affaire}
          setOpenModal={setOpenModalSaisieNotes}
          listeApprenants={listeApprenants}
          listeModules={listeModules}
          rattrapage={listeModules?.rattrapage?.length > 0  ? true : false}
          periode={periode}
          form={form}
          
        />
      )}
      {
        calendarData.length > 0 && (
  <ConsulterDetailsCalendrierExamenRattrapage
      calendarData={calendarData}
      openModal={openModal}
      setOpenModal={setOpenModal}
      />
        )
      }
   
    
    </div>
  );
};

export default ListeDesExamensEtRattrapages;
